import { render, staticRenderFns } from "./WithdrawalItem.vue?vue&type=template&id=751bffca&scoped=true"
import script from "./WithdrawalItem.vue?vue&type=script&lang=js"
export * from "./WithdrawalItem.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalItem.vue?vue&type=style&index=0&id=751bffca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751bffca",
  null
  
)

export default component.exports